import { Component } from "react";

import fallScene from "../../images/about/fall-scene.webp";
import teamNYC from "../../images/about/team-nyc.webp";
import whiteHouse from "../../images/about/white-house.webp";

class AboutSection extends Component {
  render() {
    return (
      <>
        <section className="section-sp1 about-area">
          <div className="container">
            <div className="row align-items-center mt-30">
              <div className="col-lg-6 mb-30">
                <div className="about-thumb-area">
                  <ul>
                    <li>
                      <img
                        className="about-thumb1"
                        src={fallScene}
                        alt="Fall Scene"
                      />
                    </li>
                    <li className='relative'>
                      <img
                        className="absolute about-thumb3"
                        src={teamNYC}
                        alt="Team New York City"
                      />
                    </li>
                    <li>
                      <img
                        className="exp-bx"
                        src={whiteHouse}
                        alt="White House"
                      />
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-6 mb-30">
                <div className="heading-bx">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "start",
                    }}
                  >
                    <h2 className="title-ext text-secondary">Our Culture</h2>
                  </div>
                  <h6
                    style={{
                      marginTop: "32px",
                      marginBottom: "32px ",
                      fontWeight: "400",
                    }}
                  >
                    At DigiVidBIO, enjoying what we do isn't just a perk; it's
                    the secret sauce that makes the whole process feel
                    effortless and even fun for our clients. When filming
                    becomes hectic elsewhere, we repeatedly hear from clients
                    that with us, it's a stress-free experience filled with
                    collaboration and creativity.
                    <br />
                    <br />
                    That's because we start with having a good time ourselves.
                    This positive energy flows through every project, whether
                    we're capturing footage or crafting digital campaigns that
                    take a broader view and make a meaningful impact. Open,
                    honest conversations are our foundation; it's how great
                    ideas come to life and strong partnerships grow.
                    <br />
                    <br />
                    We take pride in our work and in building genuine
                    relationships, not just chasing metrics. Our goal? To help
                    bring out the hero within every client's organization,
                    making success both meaningful and enjoyable.
                  </h6>
                </div>
              </div>
            </div>
          </div>
          {/* <img className="pt-img1 animate-wave" src={ptImg1} alt=""/> */}
        </section>
      </>
    );
  }
}

export default AboutSection;
